import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { media } from "@/config/products";

export default function Packaging() {
  const { t } = useLanguage();
  return (
    <section data-testid="packaging-section" className="bg-[#f7f7f5] py-20 lg:py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 lg:grid-cols-2 lg:px-10">
        <Reveal y={40}>
          <div className="overflow-hidden rounded-2xl border border-[#eee]">
            <img
              src={media.packaging}
              alt=""
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.packaging.title}</h2>
          <p className="mt-4 max-w-md font-body text-sm leading-relaxed text-[#666]">{t.packaging.text}</p>
        </Reveal>
      </div>
    </section>
  );
}
